import { Link } from '@tanstack/react-router'
import { ArrowRightIcon, CompassIcon, XIcon } from 'lucide-react'

import { Button } from '@/components/ui'
import {
  useGettingStartedDismissed,
  useShowGettingStartedNudges,
} from '../hooks'

// The dashboard nudge. Hidden once the account has done the work or the user
// dismissed it.
export function GettingStartedCard() {
  const show = useShowGettingStartedNudges()
  const { dismiss } = useGettingStartedDismissed()

  if (!show) return null

  return (
    <section
      aria-label="Getting started"
      className="flex flex-col gap-4 rounded-lg border border-brand/20 bg-brand/5 p-5 sm:flex-row sm:items-center"
    >
      <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-brand/10 text-brand">
        <CompassIcon className="h-5 w-5" />
      </div>
      <div className="min-w-0 flex-1">
        <h2 className="font-semibold text-blue-7">New to CounselPro?</h2>
        <p className="text-pretty text-sm text-blue-6">
          A short walkthrough from your first statement to a finished report.
          About four minutes.
        </p>
      </div>
      <div className="flex shrink-0 items-center gap-2">
        <Button asChild>
          <Link to="/getting-started" preload="intent">
            Start the walkthrough
            <ArrowRightIcon />
          </Link>
        </Button>
        <Button
          theme="ghost"
          size="md"
          isIcon
          onClick={dismiss}
          aria-label="Dismiss getting started"
        >
          <XIcon />
        </Button>
      </div>
    </section>
  )
}
